import { host, privateClient } from '.';

const path = '/locais_de_estagio';

const getBaseUrl = () => `${host}${path}`;

async function Novo(dados) {
	return await privateClient({
		path: `${path}`,
		params: {
			method: 'POST',
			body: JSON.stringify(dados),
		},
	});
}

async function ConsultaPelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
	});
}

async function ListaTodosAtestadosParaUmCurso(cursoId) {
	return await privateClient({
		path: `${path}/${cursoId}/curso_id`,
	});
}

async function ListaTodos() {
	return await privateClient({
		path: `${path}`,
	});
}

async function Atualiza(id, dados) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'PUT',
			body: JSON.stringify(dados),
		},
	});
}

async function RemovePelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'DELETE',
		},
	});
}

const camposDeEstagio = {
	getBaseUrl,
	Novo,
	ConsultaPelaId,
	ListaTodosAtestadosParaUmCurso,
	ListaTodos,
	Atualiza,
	RemovePelaId,
};

export default camposDeEstagio;
